import { Route, Router, Switch } from "react-router-dom"

// chunk was 3.21 KB
import Auth from "routes/Auth"
// we be splitting all base routes
import Base from "routes/Base"
import { I18nProvider } from "providers/I18n"
import { ReactQueryConfigProvider } from "react-query"
import { Theme } from "providers/Theme"
import { history } from "./my-history"
import { useDatadogRum } from "./hooks/useDatadogRum"
import YupLocale from "./providers/I18n/YupLocale"

const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: 0,
  },
}

export function App() {
  useDatadogRum()

  return (
    <Theme>
      <ReactQueryConfigProvider config={queryConfig}>
        <I18nProvider>
          <YupLocale />
          <Router history={history}>
            <Switch>
              <Route path="/login" component={Auth} />
              <Route component={Base} />
            </Switch>
          </Router>
        </I18nProvider>
      </ReactQueryConfigProvider>
    </Theme>
  )
}
